(ns ui.view.counterparty-diligence.responder-form.signatory-list-editor
  (:require
   [re-frame.core :as rf]
   [ui.view.counterparty-diligence.responder-form.event :as event]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.components.button.view :as button]
   [common.localization :as loc]
   [clojure.string :as string]
   [ui.view.counterparty-diligence.responder-form.validation-error-text :as error-text]))

(defn signatory-item
  [{:keys [full-name email index can-remove-signatory? state-path read-only?
           validation-errors show-validation-errors?]}]
  (let [label-prefix (str (loc/tr :signer) " " (inc index))]
    [:div
     {:class "flex gap-2 items-stretch "}
     [:div
      {:class "grow flex flex-col gap-1"}
      [labelled-input/view
       {:value full-name
        :label (str label-prefix " " (-> :full-name loc/tr string/lower-case))
        :data-type :data.type/text-simple
        :disabled? read-only?
        :on-change (fn [value]
                     (rf/dispatch-sync [::event/update-signatory-field
                                        {:field :full-name
                                         :value  value
                                         :index index
                                         :state-path state-path}]))

        :on-blur #(rf/dispatch [::event/on-blur-field
                                {:field :signatories
                                 :state-path state-path}])}]

      (when show-validation-errors?
        [error-text/view
         {:validation-errors (get-in validation-errors [:fields :full-name])}])]

     [:div
      {:class "grow flex flex-col gap-1"}
      [labelled-input/view
       {:value email
        :label (str label-prefix " " (-> :email loc/tr string/lower-case))
        :data-type :data.type/text-simple
        :disabled? read-only?
        :on-change (fn [value]
                     (rf/dispatch-sync [::event/update-signatory-field
                                        {:field :email
                                         :value  value
                                         :index index
                                         :state-path state-path}]))
        :on-blur #(rf/dispatch [::event/on-blur-field
                                {:field :signatories
                                 :state-path state-path}])}]

      (when show-validation-errors?
        [error-text/view
         {:validation-errors (get-in validation-errors [:fields :email])}])]

     (when-not read-only?
       [:div
        {:class "pt-8"}
        [button/square-secondary-open
         {:on-click #(rf/dispatch [::event/remove-signatory
                                   {:index index
                                    :state-path state-path}])
          :disabled? (not can-remove-signatory?)
          :tooltip  (when-not can-remove-signatory?
                      (loc/tr :there-must-be-at-least-one-signatory))}
         [:i.fal.fa-trash]]])]))

(defn view
  [{:keys [value field state-path read-only?
           validation-errors show-validation-errors?]}]
  (let [can-remove-signatory? (and (not read-only?)
                                   (seq value)
                                   (< 1 (count value)))]
    [:div
     {:class "flex flex-col gap-5"}

     (when (and show-validation-errors?
                (map? validation-errors))
       [error-text/view
        {:validation-errors (:general validation-errors)}])

     (when (seq value)
       [:div
        {:class "flex flex-col gap-4"}
        (->> value
             (map-indexed (fn [index signer]
                            ^{:key (str "signatory-" index)}
                            [signatory-item
                             (merge signer
                                    {:index index
                                     :field field
                                     :state-path state-path
                                     :read-only? read-only?
                                     :validation-errors (get-in validation-errors [:items index])
                                     :show-validation-errors? show-validation-errors?
                                     :can-remove-signatory? can-remove-signatory?})])))])

     (when-not read-only?
       [:div
        {:class "flex justify-start"}
        [button/sm-primary-solid
         {:on-click #(rf/dispatch [::event/add-signatory
                                   {:state-path state-path}])}
         [:i
          {:class "fal fa-plus"}]
         (loc/tr :add-signatory)]])]))
